import { RoundingMethod } from 'typings/enums';
import { observable, action, makeObservable } from 'mobx';

export class GeneralConfiguration {
    @observable percentageRounding: RoundingMethod;
    @observable hourlyRounding: RoundingMethod;
    @observable annualRounding: RoundingMethod;
    @observable stockRounding: RoundingMethod;
    @observable percentageNumberAfterDecimal: number;
    @observable hourlyNumberAfterDecimal: number;
    @observable annualNumberAfterDecimal: number;
    @observable stockNumberAfterDecimal: number;

    constructor(dto: GeneralConfiguration) {
        makeObservable(this);
        this.percentageRounding = RoundingMethod.Absolute;
        this.hourlyRounding = RoundingMethod.Absolute;
        this.annualRounding = RoundingMethod.Absolute;
        this.stockRounding = RoundingMethod.Absolute;
        this.percentageNumberAfterDecimal = dto.percentageNumberAfterDecimal;
        this.hourlyNumberAfterDecimal = dto.hourlyNumberAfterDecimal;
        this.annualNumberAfterDecimal = dto.annualNumberAfterDecimal;
        this.stockNumberAfterDecimal = dto.stockNumberAfterDecimal;
    }

    get roundingOptions(): IOption[] {
        return [
            {
                value: RoundingMethod.Absolute,
                text: 'Absolute'
            },
            {
                value: RoundingMethod.RoundDown,
                text: 'Round Down'
            },
            {
                value: RoundingMethod.RoundUp,
                text: 'Round Up'
            }
        ];
    }

    get numberAfterDecimalOptions(): IOption[] {
        return [
            {
                value: 2,
                text: '0.01'
            },
            {
                value: 1,
                text: '0.1'
            },
            {
                value: 0,
                text: '1'
            }
        ];
    }

    isAbsoluteRounding(rounding: RoundingMethod): boolean {
        return rounding === RoundingMethod.Absolute;
    }

    @action
    setPercentageRounding(rounding: RoundingMethod): void {
        this.percentageRounding = rounding;
    }

    @action
    setHourlyRounding(rounding: RoundingMethod): void {
        this.hourlyRounding = rounding;
    }

    @action
    setAnnualRounding(rounding: RoundingMethod): void {
        this.annualRounding = rounding;
    }

    @action
    setStockRounding(rounding: RoundingMethod): void {
        this.stockRounding = rounding;
    }

    @action
    setPercentageNumberAfterDecimal(numberAfterDecimal: number): void {
        this.percentageNumberAfterDecimal = numberAfterDecimal;
    }

    @action
    setHourlyNumberAfterDecimal(numberAfterDecimal: number): void {
        this.hourlyNumberAfterDecimal = numberAfterDecimal;
    }

    @action
    setAnnualNumberAfterDecimal(numberAfterDecimal: number): void {
        this.annualNumberAfterDecimal = numberAfterDecimal;
    }

    @action
    setStockNumberAfterDecimal(numberAfterDecimal: number): void {
        this.stockNumberAfterDecimal = numberAfterDecimal;
    }
}
